import React from 'react';

const PointsPolicyBanner: React.FC = () => {
  return (
    <div className="alert mb-4" 
         style={{ 
           background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
           border: '3px solid #667eea',
           borderRadius: '15px',
           color: 'white',
           boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)'
         }}>
      <div className="d-flex align-items-start">
        <i className="fas fa-trophy me-3 mt-1 d-none d-md-inline" style={{ color: '#ffd700', fontSize: '1.6rem', textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}></i>
        <div className="flex-grow-1">
          <h5 className="mb-3 fw-bold" style={{ color: 'white', textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>
            <i className="fas fa-coins me-2" style={{ color: '#ffd700' }}></i>Points & Rewards System
          </h5>
          
          <div className="row g-3">
            {/* Basic Requirements */}
            <div className="col-md-6">
              <div className="p-3 rounded" style={{ 
                backgroundColor: 'rgba(255, 255, 255, 0.15)', 
                border: '2px solid rgba(255, 255, 255, 0.3)',
                backdropFilter: 'blur(10px)'
              }}>
                <h6 className="fw-bold mb-2" style={{ color: '#ffd700' }}>
                  <i className="fas fa-exclamation-circle me-1"></i>Requirements
                </h6>
                <ul className="mb-0 small" style={{ color: 'white' }}>
                  <li><strong>Minimum 20 questions</strong> required to earn points</li>
                  <li>Complete quiz to unlock leaderboard eligibility</li>
                </ul>
              </div>
            </div>

            {/* Score-Based Points */}
            <div className="col-md-6">
              <div className="p-3 rounded" style={{ 
                backgroundColor: 'rgba(255, 255, 255, 0.15)', 
                border: '2px solid rgba(255, 255, 255, 0.3)',
                backdropFilter: 'blur(10px)'
              }}>
                <h6 className="fw-bold mb-2" style={{ color: '#ffd700' }}>
                  <i className="fas fa-chart-line me-1"></i>Score-Based Points
                </h6>
                <ul className="mb-0 small" style={{ color: 'white' }}>
                  <li><strong style={{ color: '#00ff88' }}>360 points</strong> - Excellent (90%+)</li>
                  <li><strong style={{ color: '#40e0d0' }}>240 points</strong> - Good (50-90%)</li>
                  <li><strong style={{ color: '#ffa500' }}>120 points</strong> - Fair (&lt;50%)</li>
                </ul>
              </div>
            </div>

            {/* Bonus Points */}
            <div className="col-12">
              <div className="p-3 rounded" style={{ 
                backgroundColor: 'rgba(255, 255, 255, 0.15)', 
                border: '2px solid rgba(255, 255, 255, 0.3)',
                backdropFilter: 'blur(10px)'
              }}>
                <h6 className="fw-bold mb-2" style={{ color: '#ffd700' }}>
                  <i className="fas fa-gift me-1"></i>Bonus Opportunities
                </h6>
                <div className="row">
                  <div className="col-md-4">
                    <ul className="mb-0 small" style={{ color: 'white' }}>
                      <li><strong style={{ color: '#ff6b6b' }}>+60 points</strong> - No skipped questions</li>
                      <li><strong style={{ color: '#ff6b6b' }}>+120 points</strong> - Hard difficulty quiz</li>
                    </ul>
                  </div>
                  <div className="col-md-4">
                    <ul className="mb-0 small" style={{ color: 'white' }}>
                      <li><strong style={{ color: '#ff6b6b' }}>+360 points</strong> - Perfect speed bonus</li>
                      <li><strong style={{ color: '#ff6b6b' }}>+120 points</strong> - New user welcome bonus</li>
                    </ul>
                  </div>
                  <div className="col-md-4">
                    <div className="small" style={{ color: 'white' }}>
                      <strong>Maximum potential:</strong><br />
                      <span className="badge px-3 py-2" style={{ 
                        background: 'linear-gradient(45deg, #ffd700, #ffed4e)',
                        color: '#333',
                        fontSize: '0.9rem',
                        fontWeight: 'bold',
                        textShadow: 'none',
                        boxShadow: '0 4px 15px rgba(255, 215, 0, 0.4)'
                      }}>
                        🏆 840+ points per quiz
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PointsPolicyBanner;